<template>
  <div>
    <div v-if="!inWhoInSection" class="verticalCenter order-bar">
      <b-form-select v-model="$store.state.forum.searchSort" @input="sortSelect" :options="sortOptions" class="order-by offset-sm-5 custom-select-forum"></b-form-select>
    </div>
    <div v-else-if="Object.keys(this.$store.state.forum.activityFilters).length">
      <base-button white @click="resetWhoInFilters">{{ $t('resetFilters') }}</base-button>
    </div>
    <div v-if="inWhoInSection && activitySource.length">
      <b-badge v-for="item in activitySource" :key="item.id" :class="{'activity-selected': $store.state.forum.activityFilterSelected === item.id}" class="activity-filter-block" @click="searchActivity(item.id, item.createdByUser)">{{ item[normalizeForumProp('name')] }}</b-badge>
    </div>
    <forum-article-block style="min-height: 100vh;" @loadMoreEntries="loadMoreEntries" hideForumDescriptionMobile></forum-article-block>
  </div>
</template>

<script>
import { BFormSelect, BBadge } from 'bootstrap-vue'
import forumMixin from '@/mixins/forum.mixin'
import forumRepository from '@/repositories/ForumRepository'
import BaseButton from '@/components/base/buttons/BaseButton'

export default {
  name: 'forum',
  components: {
    BFormSelect,
    BBadge,
    BaseButton,
    'forum-article-block': () => import('./ForumArticleBlock').then(m => m.default),
    'base-button': () => import('@/components/base/buttons/BaseButton').then(m => m.default),
    'LoginForm': () => import('@/components/forms/LoginForm').then(m => m.default)
  },
  props: {
  },
  mixins: [forumMixin],
  data () {
    return {
      activitySource: [],
      sortOptions: [
        { value: 0, text: this.$t('orderBy') },
        { value: 1, text: this.$t('moreRecent') },
        { value: 2, text: this.$t('featured') }
      ]
    }
  },
  created () {
    this.$store.state.forum.hideSearcher = false
    this.getForumData()
    if (this.inWhoInSection && this.$store.getters['session/healthyCommunityActive']) {
      this.getActivities()
    }
  },
  computed: {
  },
  methods: {
    forumFormSended () {
      this.getForumData()
    },
    loadMoreEntries () {
      this.$store.state.forum.entriesPageNumber += 1
      this.getForumData()
    },
    getForumData () {
      this.loadForumEntries()
    },
    sortSelect () {
      this.$store.state.forum.entriesPageNumber = 0
      this.getForumData()
    },
    resetWhoInFilters () {
      this.$store.commit('forum/setActivityFilterSelected', null)
      this.$store.commit('forum/setActivityFilters', {})
      this.getForumData()
    },
    getActivities () {
      forumRepository.getActivities(true, true).then(response => {
        this.activitySource = response.data
      })
    },
    searchActivity (activityId, createdByUser) {
      if (this.$store.state.forum.activityFilterSelected === activityId) {
        this.$store.commit('forum/setActivityFilterSelected', null)
        this.resetWhoInFilters()
      } else {
        this.$store.commit('forum/setActivityFilterSelected', activityId)
        let filter = createdByUser ? {otherActivities: true} : {activity: activityId}
        forumRepository.searchActivity(filter).then(response => {
          if (response.data && response.data.entryData.length > 0) {
              this.processForumEntry(response.data)
          } else {
              this.$store.dispatch('showInfoAlert', this.$t('emptyActivitiesSearch'))
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.order-bar{
  width: 50vw !important;
  margin-left: auto !important;
  margin-right: auto !important;
  flex-direction: row !important;
  margin-bottom: 3vh !important;
  @include media(mobile, tablets) {
    flex-direction: column !important;
    margin-bottom: 3.5vh !important;
    .custom-select-forum{
      margin-left: 0px !important;
      }
      .back-btn-search{
        margin-bottom: 2vh !important;
      }
  }
}
.custom-select-forum{
  margin-bottom: 0px !important;
}
.activity-filter-block{
  cursor: pointer;
  margin-right: 1rem;
  padding: .7em 1em;
  color: $blue;
  border: 1px solid $blue;
  background-color: transparent;
  margin-top: 1rem;
}
.activity-selected{
  background-color: $blue;
  color: $white;
}
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-community/forum/Forum.vue